import { FC } from 'react'
import classNames from 'classnames'

interface Props {
  isActive: boolean
  text: string
  onClick: () => void
}

export const TabHeader: FC<Props> = ({ isActive, text, onClick }) => {
  return (
    <button
      className={classNames(
        'homestead-tab-text uppercase hover:!text-black pb-[9px] rounded-none text-homestead-blue',
        {
          'border-b-[3px] border-homestead-red pb-[9px] !text-homestead-primary-blue': isActive,
        },
      )}
      onClick={onClick}
    >
      {text}
    </button>
  )
}
